import './publications-chart.js';
import './publication-author-map.js';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import './world.js';

window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;

import { Calendar } from 'vanilla-calendar-pro';
import 'vanilla-calendar-pro/styles/index.css';
window.calendar = Calendar;

import { prefillNewsletterForm } from './helpers/prefillNewsletterForm.js';

// Menu store
document.addEventListener('alpine:init', () => {

    // Tooltip directive
    Alpine.directive('tooltip', (el, { expression }, { cleanup }) => {
        const tooltipText = expression;

        // Create tooltip element
        const tooltip = document.createElement('div');
        tooltip.textContent = tooltipText;
        tooltip.className = 'bg-white px-3 py-2 rounded shadow-md opacity-0 transition-opacity duration-200 pointer-events-none whitespace-nowrap';
        tooltip.style.position = 'absolute';
        tooltip.style.zIndex = '9999';
        document.body.appendChild(tooltip);

        // Show tooltip on mouseenter
        const showTooltip = () => {
            const rect = el.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();

            // Center horizontally above the element
            const left = rect.left + window.scrollX + (rect.width / 2) - (tooltipRect.width / 2);
            const top = rect.top + window.scrollY - tooltipRect.height - 8;

            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;
            tooltip.style.opacity = '1';
        };

        // Hide tooltip on mouseleave
        const hideTooltip = () => {
            tooltip.style.opacity = '0';
        };

        el.style.cursor = 'pointer';
        el.addEventListener('mouseenter', showTooltip);
        el.addEventListener('mouseleave', hideTooltip);

        // Cleanup when element is removed
        cleanup(() => {
            el.removeEventListener('mouseenter', showTooltip);
            el.removeEventListener('mouseleave', hideTooltip);
            tooltip.remove();
        });
    });

    Alpine.store('menu', {
        open: false,

        toggle() {
            this.open = ! this.open
            document.body.classList.toggle('overflow-hidden');
        }
    })

    // Prefill newsletter form with email using `email` URL query parameter if present
    prefillNewsletterForm();
})
